export default "__VITE_ASSET__Blzhs67k__"